<div class="p-dialog-header px-0 border-round-top-lg flex flex-column align-items-start gap-spacing-md">
  <div class="flex justify-content-between gap-spacing-xs w-full">
    <span class="background-muted-warning-bg flex p-spacing-xs border-round-md">
      <i class="icon-warning-circle-solid text-xl icon-warning-color"></i>
    </span>
    <div class="p-dialog-header-icons">
      <app-button
        (btnClick)="ref.close()"
        [iconOnlyButton]="true"
        icon="icon-x"
        sizeClass="p-button-sm"
        severity="secondary"
        [textButton]="true"></app-button>
    </div>
  </div>

  <div class="p-dialog-title">
    <div class="flex gap-spacing-xs flex-column">
      <span class="title-small-bold text-primary-color">{{ config.data.header }}</span>
      <span class="text-caption-color label-large-medium">{{ config.data.confirmationText }}</span>
    </div>
  </div>
</div>

<div class="footer pb-spacing-2xl px-0 gap-spacing-xl flex justify-content-end gap-spacing-xl">
  <app-button
    label="Cancel"
    (btnClick)="ref.close()"
    sizeClass="p-button-md"
    severity="secondary"></app-button>
  <app-button
    [label]="'Proceed'"
    [isLoading]="loading"
    [iconStart]="loading ? 'icon-spinner-gap' : ''"
    (btnClick)="confirmAction()"
    sizeClass="p-button-md"
    [severity]="config.data.actionId == ScheduledNotificationActionType.Cancel ? 'danger' : 'primary'"></app-button>
</div>
